import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const RectangleVertical: IconNode = [
  'svg',
  defaultAttributes,
  [['rect', { width: '12', height: '20', x: '6', y: '2', rx: '2' }]],
];

export default RectangleVertical;
